import { Controller } from "@hotwired/stimulus"

// The picker keeps its selection in sessionStorage so that pressing Back from
// Stripe does not lose it. Once an order is placed that cart is spent, so the
// confirmation page drops it -- otherwise the buyer returns to the picker with
// the places they just bought still sitting in it.
export default class extends Controller {
  static values = { invitation: String }

  connect() {
    try {
      sessionStorage.removeItem(`amplify-picker-selection:${this.invitationValue}`)
    } catch {
      // Private-mode storage failures are not worth breaking the page over.
    }
  }
}
